export const query_getFascicoli = `
query getFascicoli($tenantId: String!, $aziendaId: Int!, $pageNumber: Int!, $pageSize: Int!){
  getFascicoli(tenantId: $tenantId, aziendaId: $aziendaId, pageNumber: $pageNumber, pageSize: $pageSize) {
    id
    tenantId
    name
    date
    isPrivate
    createdOn
    modifiedOn
    aziendaId
    createdBy
    modifiedBy
  }
}`;
export const query_getFascicoloStatistics = `
query getFascicoloStatistics(
    $userId: String!
    $tenantId: String!
    $aziendaId: Int!
) {
    getFascicoloStatistics(
        userId: $userId
        tenantId: $tenantId
        aziendaId: $aziendaId
        ) {
        totalFascicoli
        fascicoliAttivi
        fascicoliPrivati
        fascicoliPubblici
        fascicoliConPep
        fascicoliSenzaPep
    }
}`;
export const query_getFascicoliByAnagrafica = `
query getFascicoliByAnagrafica(
    $anagraficaId: Int!
    $userId: String!
    $includeTerminated: Boolean!
) {
    getFascicoliByAnagrafica(
        anagraficaId: $anagraficaId
        userId: $userId
        includeTerminated: $includeTerminated
    ) {
        id
        tenantId
        name
        date
        isPrivate
        createdOn
        modifiedOn
        aziendaId
        createdBy
        modifiedBy
    }
}`;
export const query_getAnagraficheByFascicolo = `
query getAnagraficheByFascicolo(
    $fascicoloId: Int!    
    $includeTerminated: Boolean!
) {
    getAnagraficheByFascicolo(
        fascicoloId: $fascicoloId        
        includeTerminated: $includeTerminated
    ) {
        id
        fascicoloId
        anagraficaId
        tipoAnagId
        tipoPartId
        tipoPartDesc
        dataFine
        tipoRapp
        tipoRappDesc
    }
}`;
export const query_getAnagraficaFascicoloById = `
query getAnagraficaFascicoloById(
    $fascicoloId: Int!
    $anagraficaFascicoloId: Int!
    $userId: String!
) {
    getAnagraficaFascicoloById(
        fascicoloId: $fascicoloId
        anagraficaFascicoloId: $anagraficaFascicoloId
        userId: $userId
    ) {
        id
        fascicoloId
        anagraficaId
        tipoAnagId
        tipoPartId
        tipoPartDesc
        dataFine
        tipoRapp
        tipoRappDesc
    }
}`;
export const query_getFascicoloById = `
query getFascicoloById($fascicoloId: Int!) {
  getFascicoloById(fascicoloId: $fascicoloId) {
    id
    tenantId
    name
    date
    isPrivate
    createdOn
    modifiedOn
    aziendaId
    createdBy
    modifiedBy
  }
}`;
export const query_fascicolo_byTenant = `
query getFascicoloByTenant($tenantId: String!, $aziendaId: Int!, $userId: String!) {
  fascicolo(where: {
    TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
    _or: [
      {IsPrivate: {_eq: false}},
      {IsPrivate: {_eq: true}, CreatedBy: {_eq: $userId}}
    ]
  }, order_by: {CreatedOn: desc}) {
    Id
    TenantId
    AziendaId
    Name
    Date
    IsPrivate
    CreatedOn
    ModifiedOn
    prestaziones {
      EndDate
      prestazione_users {
        UserId
      }
      rischios {
        ProvidedBy
      }
      rischios_aggregate {
        aggregate {
          count
        }
      }
    }
    anagrafica_fascicolos(where: {anagrafica: {IsDeleted: {_eq: false}}}) {
      anagrafica {
        IsPg
        Cf
        VersionN
        PIva
        Denominazione
        Nome
        Cognome
        Professione
        NascitaLuogo
        NascitaData
        AddrPaeseId
        AddrProvinciaId
        AddrProvincia
        AddrComuneId
        AddrComune
        AddrIndirizzo
        AddrCap
        WorkspaceId
        IdentifiedByUser
        anagrafica_fascicolos(where : {anagrafica: {IsDeleted: {_eq: false}}}, order_by: {anagrafica: {VersionN: desc}}) {
          AnagraficaId
          FascicoloId
          TipoAnagId
          TipoPartId
          TipoPartDesc
          DataFine
          TipoRappId
          TipoRappDesc
        }
      }
      base_tipo_anagrafica {
        Key
      }
    }
    indicatore_anomalia {
      Id
      Date
      ProvidedBy
      Result
      Note
      CreatedOn
      ModifiedOn
      CreatedBy
      ModifiedBy
    }
  }
}`;
export const query_fascicolo_byId = `
query getFascicoloById($id: Int!) {
  fascicolo_by_pk(Id: $id) {
    Id
    TenantId
    AziendaId
    Name
    Date
    IsPrivate
    CreatedOn
    CreatedBy
    ModifiedOn
    prestaziones {
      prestazione_users {
        UserId
      }
      rischios {
        ProvidedBy
      }
      rischios_aggregate {
        aggregate {
          count
        }
      }
    }
    anagrafica_fascicolos(where: {anagrafica: {IsDeleted: {_eq: false}}}) {
      anagrafica {
        Id
        Cf
        IsPep
        IsNotPepMoreThanYear
        IsPg
        PIva
        Denominazione
        AddrPaeseId
        AddrProvinciaId
        AddrProvincia
        AddrComuneId
        AddrComune
        AddrIndirizzo
        AddrCap
        IdentifiedByUser
        IdentifiedOn
        ModalitaIdentId
        DocTipoId  
        Professione
        Nome
        Cognome
        NascitaLuogo
        NascitaData              
        anagrafica_fascicolos(where: {FascicoloId: {_eq: $id}}) {
          Id
          AnagraficaId
          FascicoloId
          TipoAnagId
          TipoPartId
          TipoPartDesc
          DataFine
          TipoRappId
          TipoRappDesc
        }
      }
      base_tipo_anagrafica {
        Key
      }
    }
    indicatore_anomalia {
      Id
      Date
      ProvidedBy
      Result
      Note
      CreatedOn
      ModifiedOn
      CreatedBy
      ModifiedBy
    }
  }
}`;
export const query_fascicolo_byAzienda_count = `
query countFascicoloByAzienda($tenantId: String!, $aziendaId: Int!) {
  fascicolo_aggregate(where: {
    TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}
  }) {
    aggregate {
      count(columns: Id)
    }
  }
}`;
export const query_fascicolo_byTenant_byCustomer = `
query getFascicoloByTenant($tenantId: String!, $aziendaId: Int!) {
  fascicolo(where: {
      TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}
    }, order_by: {CreatedOn: desc}) {
    Id
    Name
    anagrafica_fascicolos(where: {
      anagrafica: {IsDeleted: {_eq: false}}
    }, order_by: {anagrafica: {VersionN: desc}}) {
      anagrafica {
        IsPg
        Cf
        VersionN
        PIva
        Denominazione
        WorkspaceId
      }
      base_tipo_anagrafica {
        Key
        Value
      }
    }
  }
}`;
export const query_getFascicoliAndRelatedEntities = `
query getFascicoliAndRelatedEntities($tenantId: String!, $aziendaId: Int!, $includePrivate: Boolean!, $includeTerminated: Boolean!, $onlyId: Int) {
  getFascicoliAndRelatedEntities(tenantId: $tenantId, aziendaId: $aziendaId, includePrivate: $includePrivate, includeTerminated: $includeTerminated, onlyId: $onlyId) {
    fascicoliCount  
    fascicoli {
        id
        name
        date
        isPrivate
        isCompleted
        stato
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        anagrafica {
          id
          codiceFiscale
          partitaIva
          nome
          cognome
          denominazione
          isPg
          tipoAnagrafica
          rischioGeografico
          isPep
          isNotPepMoreThanYear
          pepCarica
          pepRuolo
          identifiedByUser
        }
        anagrafiche {
          id
          codiceFiscale
          partitaIva
          nome
          cognome
          denominazione
          isPg
          tipoAnagrafica
          rischioGeografico
          isPep
          isNotPepMoreThanYear
          pepCarica
          pepRuolo
          identifiedByUser
        }
        prestazioni {
          id
          prestazioneId
          tipoPrestazione
          descrizione
          endDate
          importo
          valuta
        }
        indicatoriAnomalia {
          id
          descrizione
          data
          gravita
        }
        sos {
          id
          numero
          data
          stato
        }
    }
  }
}`;
